export default __webpack_public_path__ + "static/media/A0004.7dd4af45.png";